import React from 'react';
import { withRouter } from 'react-router-dom';
import { icons } from '../../assets';
import {
  Container,
  PowerPlug,
  MaintenanceText,
  Logo,
  Footer
} from './styles';

const Maintenance = () => (
    <Container>
      <PowerPlug>
        <img src={icons.PowerPlug} />
      </PowerPlug>

      <MaintenanceText>
        <h1>ESSE SITE ESTÁ EM MANUTENÇÃO.</h1>
        <p>Estamos trabalhando para melhor atendê-lo.</p>
      </MaintenanceText>

      <Logo>
        <img src={icons.LogotipoWhite} />
      </Logo>

      <Footer src={icons.MaintenanceBackground} />
    </Container>
);

export default withRouter(Maintenance);
